import drawLinkModel from './drawLinkModel.js'  	/*引入 绘制 文字链 模块*/
export default drawTab

function drawTab (data,moduleIndex) {
    return `<section class="tab-model">
		<div class="titleContainer">
			${data.infoList.map((item, index) => `<h1 class="titleItem titles${data.infoList.length} clickreport" data-clickLog="${`${moduleIndex}_${index}_${item.title}`}">
				<input id="titleItem-radio_${index}" class="titleItem-radio" type="radio" name="tab-title" ${index === 0 ? 'checked="checked"' : ''}/>
				<label class="titleItem-label" for="titleItem-radio_${index}">
					${item.title}
				</label>
			</h1>`).join('')}
		</div>
		<div class="contentContainer">
			${data.infoList.map((item, index) => `<div class="contentItem" ${index === 0 ? 'style="display:block"' : ''}>
				${drawTabContent(item.content,moduleIndex)}
			</div>`).join('')}
		</div>
	</section>`
}

function drawTabContent (data,moduleIndex) {
    var html = ''
    data.forEach(function (item) {
		/*4列 纯文字链 模块*/
        html += drawLinkModel.link_4(item,'',moduleIndex)
    })
    return html
}